/*
 * Created Date: Thu, 20th May 2021, 14:23:32 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2021 The Distance
 */

export const isSuperAdmin = (permissions) => permissions?.includes('SUPER_ADMIN');

export const isAdmin = (permissions) => permissions?.includes('ADMIN');

export const isEventDirector = (permissions) =>
  permissions?.includes('EVENT_DIRECTOR');
